<template>
    <div class="pmtdiv">
        <smallbutton :toplabel="name" @click="start()" v-if="showButton" :buttonclass="buttonClass"/>
        <linkbutton :toplabel="name" @click="start()" v-if="!showButton"/>
        <!--  MODAL -->
          <actionmodalwide ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform">
                    
                    <label class="titlelabel">{{name}}</label>
                    <br/>
                    <optionbutton ref="typeoptions" :itemList="ticketTypeList" @select="selectTicketType"/>
                    <optionbutton ref="employeeoptions" :itemList="filteredemp" @select="selectEmployee" v-if="IsAdmin"/>
                    <!-- <linkbutton :toplabel="toggleText" @click="showAsTickets=!showAsTickets"/> -->
                    <br>

                    <!-- generalized version -->
                    <div >
                        <div>
                            <label v-if="filteredTicketCount==0">There are no tickets</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in filteredTicketList" :key="t.id" :value="t.id" class="ticketandbuttons">
                                
                                <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="go(t.id)" toplabel="Go To Ticket" v-if="showGoButton(t)"/>
                                <smallbutton buttonclass="ticketviewbutton buttondiv marginleft"  @click="goKitchen(t)" toplabel="Fire Next" 
                                        v-if="showToKitchenButton(t)" :disabled="allItemsInKitchen(t)"/>
                                <smallbutton buttonclass="ticketviewbutton marginleft buttondiv"  @click="checkkitchendone(t)" toplabel="Order Ready" 
                                        v-if="showOrderReadyButton(t)"/>
                                <div class="margintop">
                                    <ticketv :ticket="t" :prepAreas="filteredPrepAreaList" :showTotals="showTotals" @print="printme(t.id,prepAreas)" @printreceipt="printreceiptforguest"/>
                                </div>
                                
                            </div>
                        </div>
                        <div v-if="!showAsTickets">
                            <div  v-for="t in filteredTicketList" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>


                    <!-- <div v-if="ticketType=='All Tables'">
                        <div>
                            <label v-if="suspendedTicketCount==0">There are no tickets</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in filteredList(ticketList)" :key="t.id" :value="t.id" class="ticketandbuttons">
                                
                                <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="go(t.id)" toplabel="Go To Ticket" />
                                <div class="margintop">
                                    <ticketv :ticket="t" @print="printme(t.id,prepAreas)"/>
                                </div>
                                
                            </div>
                        </div>
                        <div v-if="!showAsTickets">
                            <div  v-for="t in filteredList(ticketList)" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="ticketType=='Ready for Payment'">
                        <div>
                            <label v-if="suspendedTicketCount==0">There are no suspended tickets</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in filteredList(suspendedTicketList)" :key="t.id" :value="t.id" class="ticketandbuttons">
                                
                                <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="go(t.id)" toplabel="Go To Ticket" />
                                <div class="margintop">
                                    <ticketv :ticket="t" @print="printme(t.id,prepAreas)"/>
                                </div>
                                
                            </div>
                        </div>
                        <div v-if="!showAsTickets">
                            <div  v-for="t in filteredList(suspendedTicketList)" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>
                     <div v-if="ticketType=='Seated'">
                        <div>
                            <label v-if="seatedTicketCount==0">There are no seated tickets</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in filteredList(seatedTicketList)" :key="t.id" :value="t.id" class="ticketandbuttons">
                                 <div class="horizFlexStretch ">
                                    <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="cancelThisTicket(t.id)" toplabel="Walk Out" />
                                 <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="go(t.id)" toplabel="Go To Ticket" />
                                 </div>
                                
                                <div class="margintop">
                                    <ticketv :ticket="t" @print="printme(t.id,prepAreas)"/>
                                </div>
                                
                            </div>
                        </div>
                        <div v-if="!showAsTickets">
                            <div  v-for="t in filteredList(seatedTicketList)" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)" />
                            </div>
                        </div>
                    </div>
                    <div v-if="ticketType=='Completed'">
                        <div>
                            <label v-if="completedTicketCount==0">There are no completed tickets today</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in filteredList(completedTicketList)" :key="t.id" :value="t.id" class="ticketandbuttons">
                                <ticketv :ticket="t" @print="printme(t.id,prepAreas)"/>
                                
                            </div>
                        </div>
                        <div v-if="!showAsTickets">
                            <div  v-for="t in filteredList(completedTicketList)" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="ticketType=='Kitchen'">
                        <div>
                            <label v-if="kitchenTicketCount==0">There are no kitchen tickets</label>
                        </div>
                        <div class="horizFlex" v-if="showAsTickets">
                            <div  v-for="t in filteredList(kitchenTicketList)" :key="t.id" :value="t.id" class="ticketandbuttons">
                                
                                <div class="horizFlexStretch ">
                                    <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="checkkitchendone(t)" toplabel="Order Ready" />
                                    <smallbutton buttonclass="ticketviewbutton buttondiv"  @click="go(t.id)" toplabel="Go To Ticket" />

                                </div>
                                <div class="margintop">
                                    <ticketv :ticket="t" :prepAreas="prepAreas" @print="printme(t.id,prepAreas)"/>
                                </div>
                                
                            </div>
                        </div>
                         <div v-if="!showAsTickets">
                            <div  v-for="t in filteredList(kitchenTicketList)" :key="t.id" :value="t.id" >
                                <ticketh :ticket="t" @gototicket="go(t.id)"/>
                            </div>
                        </div>
                    </div>
                                -->
         
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
         
                </form>
                
                <confirm ref="confirmdonekitchen" :showLink="falseParam" body="Not all of the items have been sent to the kitchen. Do you want to mark this ticket Ready for Payment?" title="Order Ready" @yes="kitchendone(ticketToBeDone)" />
                <tokitchen ref="tokitchen" @refresh="getAllTickets" />
                <receiptoptions ref="receiptoptions"  :showButton="falseParam"/>  
            </template>
          </actionmodalwide>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodalwide from '../controls/actionmodalwide.vue'
    import formentry from '../controls/entry.vue'
    import datamethods from '../../services/datamethods.js'
    import confirm from '../actions/confirm.vue'
    import ticketv from './ticketv.vue'
    import ticketh from './ticketh.vue'
    import pos from '../../services/pos.js'
    import pay from '../../services/pay.js'
    import pos_culinary from '../../services/pos_culinary.js'
    import optionbutton from '../controls/optionbutton.vue'
    import printreceipthelper from '../../services/printreceipthelper.js'
    import tokitchen from '../actions/tokitchen.vue';
    import receiptoptions from '../actions/receiptoptions.vue'
    export default {
        name:'ticketshoriz',
        components:{
            smallbutton,
            actionmodalwide,
            formentry,
            linkbutton,
            confirm,
            ticketv,
            optionbutton,
            ticketh,
            tokitchen,
            receiptoptions
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:true
            },
            name:{
                type:String,
                default:"Today's Tickets"
            },
            defaultAmount:{
                type:Number,
            },
            numberDataLabel:{
                type:String,
                default:''
            },
            buttonClass:{
                type:String,
                default:'button buttonprimary bottom10'
            }
            
        },
        mixins:[format, datamethods,pos,pay,pos_culinary,printreceipthelper],
       
        data(){
            return{
                ticketToBeDone:null,
                showAsTickets:true,

                param2:0,

                ticketTypeList:[
                    {
                        id:-1,
                        name:'All Tables',
                        statusName:'All',
                        selected:false
                    },
                    {
                        id:0,
                        name:'Seated',
                        statusName:'Waiting',
                        selected:false
                    },
                    {
                        id:1,
                        name:'Kitchen',
                        statusName:'InKitchen',
                        selected:false
                    },
                    {
                        id:2,
                        name:'Ready for Payment',
                        statusName:'InService',
                        selected:false
                    },
                    {
                        id:3,
                        name:'Paid',
                        statusName:'CheckedOut',
                        selected:false
                    }
                ],
                ticketType:'Kitchen',
                ticketStatusName:'InKitchen',

                ticketList:[],
                suspendedTicketList:[],
                kitchenTicketList:[], 
                completedTicketList:[],
                seatedTicketList:[],

                ticketId:0,
                trueParam:true, 
                falseParam:false,
                savedTicketId:0,

                ticketEmployeeList:[],
                filterEmployeeId:-1

            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait',
                'location',
                'terminalId',
                'businessDayId',
                'prepAreas'
     
            ]),
            
            showTotals(){
                if(this.ticketStatusName.includes('Kitchen')){return false}
                else{return true}
            },
            toggleText(){
                if(this.showAsTickets){return "Show as Records"}
                else{return "Show as Tickets"}
            },
           ticketCount(){
            return this.ticketList.length
           },
   
           suspendedTicketCount(){
            return this.suspendedTicketList.length
           },
           kitchenTicketCount(){
            return this.kitchenTicketList.length
           },
           completedTicketCount(){
                return this.completedTicketList.length
           },
           seatedTicketCount(){
                return this.seatedTicketList.length
           },
            filteredTicketCount(){
                return this.filteredTicketList.length
            },
            filteredPrepAreaList(){
                if(this.ticketStatusName=='InKitchen'){return this.prepAreas}
                else{
                    var emptyprep=[]
                    return emptyprep
                }
            },
            filteredTicketList(){
                var statusName = this.ticketStatusName
               
                var emp=this.filterEmployeeId
                
                if(emp==-1 && statusName=='All'){return this.ticketList}

                var filtered =[]
                this.ticketList.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if((t.employeeId== emp || emp==-1) && (t.statusName==statusName || statusName=='All') ){
                        filtered.push(t)
                    }
                } 
                return filtered
            },
            filteredemp(){

                
                var filtered =[]
                this.ticketEmployeeList.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if((t.name!=null && t.name !='') ){
                        filtered.push(t)
                    }
                } 
                return filtered
            },
           /* kitchenTicketList(){
                let temp = this.ticketList;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        return (item.statusName=='InKitchen')
                    })
                }
                
                return temp
           },
           suspendedTicketList(){
            let temp = this.ticketList;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        return (item.statusName=='InService')
                    })
                }
                
                return temp
           },
           completedTicketList(){
            let temp = this.ticketList;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        return (item.statusName=='CheckedOut')
                    })
                }
                
                return temp
           } */
        },
        methods:{
            showOrderReadyButton(t){
                return this.ticketStatusName.includes('Kitchen') && !this.hasKitchenAdmin && this.allItemsInKitchen(t)
            },
            showToKitchenButton(t){
                return this.ticketStatusName.includes('Kitchen') && !this.allItemsInKitchen(t)
            },
            showGoButton(t){
                return !this.ticketStatusName.includes('CheckedOut')
            },
           goKitchen(ticket){
            this.setCurrentTicket(ticket)
            this.$refs.tokitchen.Show()
           },
           
            filteredList(inlist){
                var emp=this.filterEmployeeId
                
                if(emp==-1){return inlist}

                var filtered =[]
                inlist.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.employeeId== emp){
                        filtered.push(t)
                    }
                } 
                return filtered
           },
           
            async printme(id,prepAreas){
                this.receiptPrintJob = await this.printTicketDirect(id)
                this.printReceiptDirect(this.receiptPrintJob)
            },
            async printreceiptforguest(guestNumber,ticket){
                console.log('print receipt for guest ' + guestNumber)
                this.openReceiptOptions(guestNumber,ticket)
                //this.receiptPrintJob = await this.printReceiptDirectForCurrentTicket(guestNumber)
                //this.printReceiptDirect(this.receiptPrintJob)
            },
            selectTicketType(id,name){
                //console.log('select type ' + name)
                this.ticketType=name
                this.ticketTypeList.forEach(myFunction2)
                var statusName
                function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.name== name){
                        statusName=t.statusName
                    }
                } 
                this.ticketStatusName=statusName
            },
            selectEmployee(id,name){
                this.filterEmployeeId=id
                
            },
            go(ticketid){
                var gotopay=false
                if(this.ticketStatusName=='InService'){gotopay=true}
                this.gototicket(ticketid,false,gotopay)
                this.$refs.mymodal.closeModal()
            },
            checkkitchendone(ticket){
                if(this.allItemsInKitchen(ticket)){
                    this.kitchendone(ticket)
                    return
                }
                this.ticketToBeDone=ticket
                this.$refs.confirmdonekitchen.Show()
            },
            async kitchendone(ticket){
                console.log('ticket to suspend')
                await this.suspendticket(ticket)
                if(this.ticketDue(ticket)==0){
                    console.log('ticket  to check out')
                    await this.process_SelectedTicket(ticket)//complete, no receipt (done already)

                }
                
                this.getAllTickets()
            },
            async cancelThisTicket(id){
                await this.cancelTicket(id)
                this.getAllTickets()
            },
            toDate(dt){
                return this.$options.filters.formatTime_NoSeconds(dt);
            },
            
        
            tclass(g){
                let c = "tclass"
                return c
            },
            
            start(){
                if(this.prepAreas.length==0){this.GetPrepAreas()}

                //if we are not admin, set filter employee to logged in employee
                if(!this.IsAdmin){
                    this.selectEmployee(this.loggedInUser.user_personId, this.loggedInUser.name)
                }

                this.getAllTickets()

                this.$refs.mymodal.openModal()
                this.$nextTick(() => {
                    this.$refs.typeoptions.selectbyid(1,'Kitchen')
                    this.$refs.employeeoptions.selectbyid(-1,'All')
                    
                })
                
            },
            //this is the new one
            async getAllTickets(){
                

                //this.inPayment=true
                let req = {
                    locationId:this.location.id,
                    terminalId:this.terminalId,
                    employeeId:this.filterEmployeeId
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'gettodaytickets_ticketview')
                //handle response
            
                if(response.Successful){
                    this.ticketList=response.ticketList
                    if(this.filterEmployeeId==-1){
                        this.ticketEmployeeList=response.employeeList
                        var all = {id:-1,name:'All Servers'}
                        this.ticketEmployeeList.unshift(all)
                    } //only set the list whenw e are getting all
                    //await this.sortTickets()

                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            
            },
            
            //this is the old one...
            /* async getAllTickets(){
                //this.inPayment=true
                let req = {
                    locationId:this.location.id,
                    terminalId:this.terminalId
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'gettodaytickets_all')
                //handle response
            
                if(response.Successful){
                    this.ticketList=response.ticketList
                    
                    

                    await this.fillInLineItems()

                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            
            }, */
            
            
            async sortTickets(){
                this.kitchenTicketList=[];
                this.suspendedTicketList=[];
                this.completedTicketList=[];
                this.seatedTicketList=[]
                var i;
                    for (i = 0; i <= this.ticketList.length - 1; i++) {
                    
                        var tick = this.ticketList[i]
                        switch (tick.statusName) {
                            case 'InKitchen':
                                this.kitchenTicketList.push(tick)
                                
                                break;
                            case 'InService':
                                this.suspendedTicketList.push(tick)
                                break;
                            case 'CheckedOut':
                                this.completedTicketList.push(tick)
                                break;
                            case 'Waiting':
                                this.seatedTicketList.push(tick)
                                break;
                            default:
                                break;
                        }
                    
                    }
            
            },
            async fillInLineItems(){
                this.kitchenTicketList=[];
                this.suspendedTicketList=[];
                this.completedTicketList=[];
                this.seatedTicketList=[]
                var i;
                    for (i = 0; i <= this.ticketList.length - 1; i++) {
                    

                        //this.ticketList[i]= await this.getticketdetail(this.ticketList[i].id)
                        var tick = await this.getticketdetail(this.ticketList[i].id)
                        switch (tick.statusName) {
                            case 'InKitchen':
                                this.kitchenTicketList.push(tick)
                                
                                break;
                            case 'InService':
                                this.suspendedTicketList.push(tick)
                                break;
                            case 'CheckedOut':
                                this.completedTicketList.push(tick)
                                break;
                            case 'Waiting':
                                this.seatedTicketList.push(tick)
                                break;
                            default:
                                break;
                        }
                    
                    }
            },
           
            async getticketdetail(id){
                let req = {
                    ticket:{
                        id:id
                    }
                }  
                    //call api
                    this.$store.dispatch('beforeAPI');
                    var response = await this.callAPI(req,'ticket')
                    //handle response
                
                    if(response.Successful){
                    return response.ticket

                    
                    
                    }else{
                    this.responseMessage = response.Message
                    }
                    this.pleaseWait=false;
            },
            setupTypes(){
                this.ticketTypeList=[
                    {
                        id:-1,
                        name:'All Tables',
                        statusName:'All',
                        selected:false
                    },
                    {
                        id:0,
                        name:this.seatedTextOverride,
                        statusName:'Waiting',
                        selected:false
                    },
                    {
                        id:1,
                        name:'Kitchen',
                        statusName:'InKitchen',
                        selected:false
                    },
                    {
                        id:2,
                        name:'Ready for Payment',
                        statusName:'InService',
                        selected:false
                    },
                    {
                        id:3,
                        name:'Paid',
                        statusName:'CheckedOut',
                        selected:false
                    }
                ]
            }
                
        },
        mounted(){
            this.setupTypes()
        }



       
    }
    
    </script>
    
    <style>
   
    
   
    .leftjustify{
        text-align: left;
    }
    .rightjustify{
        text-align: right;
    }
    .ticketviewbutton{
        background-color: var(--ticket-action-buttoncolor);
        color:var(--light-text-color);
        border: none;
    border-radius:3px;
    width:95px;
    height:35px;
    padding:0px;
    font-size: medium;
    margin:0px;
  text-decoration: none;
    }
    .buttondiv{
        margin-top:5px;
    }
    .ticketandbuttons{
        margin:5px;
    }
    .margintop{
        margin-top: 5px;
    }
    .marginleft{
        margin-left:5px;
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    